import { render } from "./activities-notification.vue?vue&type=template&id=467e6d52&scoped=true"
import script from "./activities-notification.vue?vue&type=script&lang=js"
export * from "./activities-notification.vue?vue&type=script&lang=js"

import "./activities-notification.vue?vue&type=style&index=0&id=467e6d52&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467e6d52"]])

export default __exports__